import {FEATURE_FLAGS} from "@utils/storageKeys";

// Pre-release features: off unless a browser opens the app with ?features=<key>[,<key>], which
// keeps them on there (logging out included); ?features=-<key> turns one back off. Remove a key,
// and its checks, once the feature is out for everyone.
export const PRE_RELEASE = [];

const stored = () => {
  try {
    return new Set(JSON.parse(localStorage.getItem(FEATURE_FLAGS)) || []);
  } catch {
    return new Set();
  }
};

let enabled = stored();

// Applies the ?features= param of the URL the app was opened with.
export const applyFeatureParam = (search) => {
  const param = new URLSearchParams(search).get('features');
  if (!param) return;
  enabled = stored();
  for (const entry of param.split(',')) {
    const key = entry.trim().replace(/^-/, '');
    if (!PRE_RELEASE.includes(key)) continue;
    if (entry.trim().startsWith('-')) enabled.delete(key);
    else enabled.add(key);
  }
  try {
    localStorage.setItem(FEATURE_FLAGS, JSON.stringify([...enabled]));
  } catch {
    // storage blocked: the flags still hold until the page reloads
  }
};

export const isFeatureEnabled = (key) => PRE_RELEASE.includes(key) && enabled.has(key);
